import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ModalLoader } from "src/components/modalLoader";
import { api } from "src/services/api";
import { currencyFormat, currencyFormatTrio } from "src/utils/currencyFormat";
import { setAuthToken } from "src/utils/setAuthToken";

const fetchBalance = async () => {
	setAuthToken();
	const response = await api.get("/balancete");

	return response.data;
};

export const UserWallet = () => {
	const navigate = useNavigate();
	const user = JSON.parse(localStorage.getItem("@stricv2:user") as string);
	const { data, isLoading } = useQuery({
		queryFn: fetchBalance,
		queryKey: ["balancete"],
	});

	console.log(data);

	useEffect(() => {
		if (user.role === "WALLET") {
			navigate("/wallet/adds-founds-wallet");
		}
	}, [user, navigate]);

	if (isLoading) {
		return <ModalLoader />;
	}

	return (
		<section className="w-[70%] flex flex-col items-center">
			<div className="w-[90%] mt-8">
				<h2 className="text-4xl ">BALANCETE</h2>
			</div>
			<div className="w-[90%] mt-8 border border-[#B6B6B694] flex justify-between items-center">
				<div className="p-14">
					<p className="text-3xl text-[#8A8A8A]">SALDO LIQUIDO</p>
					<p className="text-3xl font-bold">
						{currencyFormat(data.netBalance)}
					</p>
				</div>
				<div className="bg-[#D0D0D0] w-[1px] h-[150px]" />
				<div className="p-14">
					<p className="text-3xl text-[#8A8A8A]">SALDO BRUTO</p>
					<p className="text-3xl font-bold">{currencyFormat(data.balance)}</p>
				</div>
				<div className="bg-[#D0D0D0] w-[1px] h-[150px]" />
				<div className="p-14">
					<p className="text-3xl text-[#8A8A8A]">SALDO A REPASSAR</p>
					<p className="text-3xl font-bold">
						{currencyFormat(data.balanceToTransfer)}
					</p>
				</div>
			</div>
		</section>
	);
};
